'use client';

import { useId } from 'react';

interface VioAvatarProps {
  /** Rendered size in px — the viewBox is square, so this sets both dimensions. */
  size?: number;
  className?: string;
  /** Pulses the visor lights. Turn off in dense lists where motion would be noisy. */
  animate?: boolean;
}

/**
 * Vio's avatar chip — the copper roundel used anywhere the assistant
 * needs a compact face: launcher buttons, panel headers, message
 * avatars. For the full-body illustration (empty states, onboarding)
 * use `VioFigure` instead.
 */
export function VioAvatar({ size = 32, className, animate = true }: VioAvatarProps) {
  const gradId = `vio-avatar-grad-${useId()}`;

  return (
    <svg aria-hidden className={className} height={size} viewBox="0 0 64 64" width={size}>
      <defs>
        <radialGradient cx="30%" cy="20%" id={gradId} r="95%">
          <stop offset="0%" stopColor="#E7BE94" />
          <stop offset="100%" stopColor="#A5652A" />
        </radialGradient>
      </defs>
      <rect fill={`url(#${gradId})`} height="64" rx="20" width="64" />
      <circle cx="32" cy="9" fill="#ECC9A8" r="3.6" />
      <line stroke="#8F5420" strokeLinecap="round" strokeWidth="2" x1="32" x2="32" y1="12" y2="18" />
      <rect fill="#8F5420" fillOpacity="0.38" height="12" rx="6" width="30" x="17" y="26" />
      <circle className={animate ? 'vio-light' : undefined} cx="26" cy="32" fill="#FBFAF6" r="2.6" />
      <circle
        className={animate ? 'vio-light' : undefined}
        cx="38"
        cy="32"
        fill="#FBFAF6"
        r="2.6"
        style={animate ? { animationDelay: '0.5s' } : undefined}
      />
    </svg>
  );
}
